import { Navigate, useLocation, useParams } from "react-router-dom";
import { usePortalEventUrls } from "../../portal/usePortalEventUrls";
import { BseSupplierView } from "./BseSupplierView";
import { v1SupplierViewLinkToPortal } from "./v1SupplierViewLinkToPortal";

export const BseSupplierViewRoute = () => {
  const { eventId } = useParams();
  const location = useLocation();
  const portalUrls = usePortalEventUrls();

  if (eventId) {
    return <Navigate to={v1SupplierViewLinkToPortal(eventId, location.search, portalUrls.view)} replace />;
  }

  return <BseSupplierView />;
};
